@if (companyClients.length > 0 && !isLoading) {
  <div class="table-container">
    <table
      mat-table
      [dataSource]="companyClients"
      class="company-clients-table"
    >
      <!-- Ragione Sociale Column -->
      <ng-container matColumnDef="ragioneSociale">
        <th mat-header-cell *matHeaderCellDef>Ragione Sociale</th>
        <td mat-cell *matCellDef="let client">{{ client.company_name }}</td>
      </ng-container>
      <!-- Partita IVA Column -->
      <ng-container matColumnDef="partitaIva">
        <th mat-header-cell *matHeaderCellDef>Partita IVA</th>
        <td mat-cell *matCellDef="let client">{{ client.vat_number }}</td>
      </ng-container>
      <!-- Paziente Column -->
      <ng-container matColumnDef="paziente">
        <th mat-header-cell *matHeaderCellDef>Paziente</th>
        <td mat-cell *matCellDef="let client">
          {{ client.patient_first_name }} {{ client.patient_last_name }}
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let client">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="modifyClient(client)">
              <mat-icon>edit</mat-icon>
              <span>Modifica</span>
            </button>
            <button mat-menu-item (click)="deleteClient(client)">
              <mat-icon>delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}

@if (companyClients.length === 0 && !isLoading) {
  <div class="no-clients-container">
    <img src="assets/imgs/undraw/undraw_development.svg" />
    <span>Nessun cliente azienda trovato</span>
  </div>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}
